module.exports = {"131082001":"鼎盛东大街街道","131082002":"泃阳西大街街道","131082100":"泃阳镇","131082101":"李旗庄镇","131082102":"杨庄镇","131082103":"皇庄镇","131082104":"新集镇","131082105":"段甲岭镇","131082106":"黄土庄镇","131082107":"高楼镇","131082108":"齐心庄镇","131082109":"燕郊镇","131082450":"燕郊经济技术开发区","131082451":"三河市农业高新技术园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131082.json
// module id = 242
// module chunks = 0